import { motion } from "framer-motion";
import BuyButton from "./CtaButton";
import { IMG, PRICE } from "../config";

const SHEETS = IMG.sheets;

export default function WhatYouGet() {
    return (
        <section
            id="what-you-get"
            data-testid="what-you-get-section"
            className="scroll-mt-24 bg-white py-16 sm:py-24"
        >
            <div className="mx-auto max-w-6xl px-4 sm:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.6 }}
                    className="mx-auto max-w-3xl text-center"
                >
                    <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
                        देखिए कौन-कौन सी Books हैं Bundle में
                    </h2>
                    <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
                        Rich Dad Poor Dad, Atomic Habits, Psychology of Money,
                        Ikigai जैसी 12,000+ Bestseller Books —{" "}
                        <span className="font-semibold text-emerald-700">
                            Hindi &amp; English दोनों में
                        </span>
                    </p>
                </motion.div>

                <div className="mt-10 gap-4 sm:columns-2 sm:gap-5">
                    {SHEETS.map(({ src, alt }, i) => (
                        <motion.div
                            key={src}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.1 }}
                            transition={{
                                duration: 0.55,
                                delay: (i % 2) * 0.08,
                            }}
                            className="mb-4 break-inside-avoid sm:mb-5"
                        >
                            <img
                                src={src}
                                alt={alt}
                                loading="lazy"
                                data-testid="bundle-preview-sheet"
                                className="w-full rounded-2xl border border-emerald-100 bg-white shadow-soft transition-transform duration-300 hover:scale-[1.015]"
                            />
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}
                    className="mt-4 text-center"
                >
                    <p
                        data-testid="bundle-examples-note"
                        className="text-sm font-semibold text-slate-700 sm:text-base"
                    >
                        ये सिर्फ कुछ examples हैं — Bundle में{" "}
                        <span className="font-bold text-orange-600">
                            12,000+ eBooks
                        </span>{" "}
                        हैं! 🔥
                    </p>
                    <div className="mt-5 flex justify-center">
                        <BuyButton
                            testId="whatyouget-cta"
                            className="w-full sm:w-auto"
                        >
                            पूरी Library Unlock करे — ₹{PRICE.current} 🔓
                        </BuyButton>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
